module.exports = __webpack_public_path__ + "media/images/pepsi_home/geo_icon-350d129dea6e129e56e079a294cbf05a.svg";